import apiService from 'utils/apiService'
import { convertObjectToQuerystring } from 'utils/storageUtils'
import { isEmpty } from 'lodash'

export function uploadMedia_api(data) {
  return apiService(`media/upload`, data, 'post', null, true)
}

export function getRecentActivities_api() {
  return apiService(`recent-activities`, null, 'get', true)
}

export function getAppVersion_api() {
  return apiService(`utility/appVersion`, null, 'get', true)
}

export function register_api(data) {
  return apiService(`auth/register`, data, 'post', '')
}
export function login_api(data) {
  return apiService(`auth/login`, data, 'post', '')
}

export function checkIfUserHasPassword_api(email) {
  return apiService(`auth/has-password?email=${email}`, null, 'get', '')
}

export function socialLogin_api(data) {
  return apiService(`auth/socialLogin`, data, 'post', '')
}
export function sendForgotPassword_api(email) {
  return apiService(`auth/forgotPassword/${email}`, null, 'post', '')
}

export function updateProfile_api(data) {
  return apiService(`auth/profile`, data, 'put', true)
}

export function logout() {
  return apiService('auth/logout', null, 'post', true)
}

export function getUserProfile_api() {
  return apiService(`auth/profile`, null, 'get', true)
}

export function getInvitation_api(filters) {
  let filter = ''
  if (!isEmpty(filters)) {
    filter = `&${convertObjectToQuerystring(filters)}`
  }
  return apiService(`company/getInvitedUser?${filter}`, null, 'get')
}

export const updateFCMToken_api = (data) => {
  return apiService(`notifications/updateFCMToken`, data, 'put', true)
}
export const notifyDraftMentionedUser_api = (data) => {
  return apiService(`notifications/notifyDraftMentionedUser`, data, 'put', true)
}

export const addTrafficSource_url = (data) => {
  return apiService('addTrafficSource', data, 'post')
}

export const getmyTeams_api = (filters) => {
  let filter = ''
  if (!isEmpty(filters)) {
    filter = `&${convertObjectToQuerystring(filters)}`
  }
  return apiService(`teams?${filter}`, null, 'get', true)
}
export const createTeam_api = (data) => {
  return apiService(`teams`, data, 'post', true)
}
export const updateTeam_api = (data, id) => {
  return apiService(`teams/${id}`, data, 'put', true)
}
export const deleteTeam_api = (id) => {
  return apiService(`teams/${id}`, null, 'delete', true)
}

export const createTeamUsers_api = (data) => {
  return apiService(`teamusers`, data, 'post', true)
}

export const getCompany_api = () => {
  return apiService(`company`, null, 'get', true)
}
export const getTotalItemsCount_api = () => {
  return apiService(`getTotalItemsCount`, null, 'get', true)
}
export const getCompanyByUUID_api = (uuid) => {
  return apiService(`company/${uuid}`, null, 'get', true)
}
export const createCompany_api = (data) => {
  return apiService(`company`, data, 'post', true)
}
export const updateCompany_api = (data, id) => {
  return apiService(`company/${id}`, data, 'put', true)
}
export const deleteCompany_api = (id) => {
  return apiService(`company/${id}`, null, 'delete', true)
}

// Company Members
export const getMembers_api = () => {
  return apiService(`company_members`, null, 'get', true)
}
export const resendInvitation_api = (member_code) => {
  return apiService(`company_members/resend-invite/${member_code}`, null, 'post', true)
}
export const inviteUsers_api = (data) => {
  return apiService(`company_members`, data, 'post', true)
}
export const deleteCompanyMember_api = (member_code, data = {}) => {
  return apiService(`company_members/${member_code}`, data, 'delete', true)
}
export const updateCompanyMember_api = (data) => {
  return apiService(`company_members/${data.member_code}`, data, 'put', true)
}
export const removeInvitation_api = (member_code) => {
  return apiService(`company_members/remove_invitation/${member_code}`, null, 'delete', true)
}
export function updateOnboardingStep_api(data) {
  return apiService(`company_members/updateOnboardingStep`, data, 'put', true)
}


//Change Ownership

export function changeOwnership_api(data) {
  return apiService(`company/change-ownership`, data, 'post', true)
}

// Notifications
export function getNotifications_api(filters) {
  let filter = ''
  if (!isEmpty(filters)) {
    filter = `&${convertObjectToQuerystring(filters)}`
  }
  return apiService(`notifications?${filter}`, null, 'get', true)
}

export function markAsReadNotification_api(id) {
  return apiService(`notifications/mark-as-read/${id}`, null, 'put', true)
}

export function getGICountryCodes_api() {
  return apiService(`utility/getCountryList`, null, 'get', null)
}

// Drafts
export function createDraft_api(data) {
  return apiService(`contents/drafts`, data, 'post', true)
}
export function getDrafts_api(filters = {}) {
  let filter = ''
  if (!isEmpty(filters)) filter = `&${convertObjectToQuerystring(filters)}`
  return apiService(`contents/drafts?${filter}`, null, 'get', true)
}
export function getDraftsById_api(uuid) {
  return apiService(`contents/drafts/${uuid}`, null, 'get', true)
}
export function updatePageDraft_api(data) {
  return apiService(`contents/drafts/${data.uuid}`, data, 'put', true)
}
export function drageAndDropPageDraft_api(data, uuid) {
  return apiService(`contents/drageAndDropPageDraft/${uuid}`, data, 'put', true)
}
export function publishDraft_api(uuid, data) {
  return apiService(`contents/drafts/publish/${uuid}`, data, 'put', true)
}
export function saveDraftVersion_api(data) {
  return apiService(`contents/drafts/saveDraftVersion`, data, 'post', true)
}
export function renameVersion_api(data) {
  return apiService(`contents/renameVersion/${data.id}`, data, 'put', true)
}
export function duplicateVersion_api(id) {
  return apiService(`contents/duplicateVersion/${id}`, null, 'post', true)
}

// PAGE CATEGORIES
export function getCategories_api(filters = {}) {
  let filter = ''
  if (!isEmpty(filters)) filter = `&${convertObjectToQuerystring(filters)}`
  return apiService(`contents/categories?${filter}`, null, 'get', true)
}
export function getCategorybyId_api(uuid) {
  return apiService(`contents/categories/${uuid}`, null, 'get', true)
}

export function createCategory_api(data) {
  return apiService(`contents/categories`, data, 'post', true)
}
export function updateCategory_api(data) {
  return apiService(`contents/categories/${data.uuid}`, data, 'put', true)
}
export function deleteCategory_api(uuid) {
  return apiService(`contents/categories/${uuid}`, null, 'delete', true)
}
export function categorySharing_api(data) {
  return apiService(`contents/categories/sharing`, data, 'post', true)
}

// Contents
export function createContent_api(data) {
  return apiService(`contents/contents`, data, 'post', true)
}
export function updateContent_api(data) {
  return apiService(`contents/contents/${data.uuid}`, data, 'put', true)
}
export function getContents_api(filters = {}) {
  let filter = ''
  if (!isEmpty(filters)) filter = `&${convertObjectToQuerystring(filters)}`
  return apiService(`contents/contents?${filter}`, null, 'get', true)
}
export function getPrivateAndFavoriteContents_api(filters = {}) {
  let filter = ''
  if (!isEmpty(filters)) filter = `&${convertObjectToQuerystring(filters)}`
  return apiService(`contents/getPrivateAndFavoriteContent?${filter}`, null, 'get', true)
}
export function getContentByUUID_api(uuid) {
  return apiService(`contents/contents/${uuid}`, null, 'get', true)
}
export function deleteContent_api(id) {
  return apiService(`contents/contents/${id}`, null, 'delete', true)
}
export function contentSharing_api(data) {
  return apiService(`contents/sharing`, data, 'post', true)
}
export function importResponsesFromTray_api() {
  return apiService(`contents/importTrayResponses`, null, 'post', true)
}
export function duplicatePage_api(id) {
  return apiService(`contents/duplicatePage/${id}`, null, 'post', true)
}
export function markAsFavorite_api(uuid) {
  return apiService(`contents/mark_as_favorite/${uuid}`, null, 'post', true)
}
export function pinToCategory_api(uuid) {
  return apiService(`contents/pin_to_category/${uuid}`, null, 'post', true)
}
export function checkShortcut_api(filters) {
  let filter = ''
  if (!isEmpty(filters)) filter = `&${convertObjectToQuerystring(filters)}`
  return apiService(`contents/checkShortcut?${filter}`, null, 'get', true)
}

//Page Sharing
export function createPageSharing_api(uuid) {
  return apiService(`contents/guestShare/${uuid}`, null, 'post', true)
}
export function deletePageSharing_api(uuid) {
  return apiService(`contents/guestShare/${uuid}`, null, 'delete', true)
}
export function updatePageSharing_api(uuid, data) {
  return apiService(`contents/guestShare/${uuid}`, data, 'post', true)
}
export function getPageSharing_api(uuid, password) {
  if (password) {
    return apiService(`contents/guestShare/${uuid}/${password}`, null, 'get')
  } else {
    return apiService(`contents/guestShare/${uuid}`, null, 'get')
  }
}
export function getPageSharingConfig_api(uuid) {
  return apiService(`contents/guestShare/config/${uuid}`, null, 'get')
}
export function requestUnlock_api(uuid) {
  return apiService(`contents/guestShare/request_unlock/${uuid}`, { _method: 'patch' }, 'post')
}

// COMMENTS
export function getComments_api(filters) {
  let filter = ''
  if (!isEmpty(filters)) filter = `&${convertObjectToQuerystring(filters)}`
  return apiService(`contents/comments?${filter}`, null, 'get', true)
}
export function addComment_api(data) {
  return apiService(`contents/comments`, data, 'post', true)
}
export function updateComment_api(data, id) {
  return apiService(`contents/comments/${id}`, data, 'put', true)
}
export function deleteComment_api(id) {
  return apiService(`contents/comments/${id}`, null, 'delete', true)
}

// MISC.
export function updatePublishedContent_api(data, uuid) {
  return apiService(`contents/updatePublishedContent/${uuid}`, data, 'put', true)
}
export function drageAndDropPublishedContent_api(data, uuid) {
  return apiService(`contents/drageAndDropPublishedContent/${uuid}`, data, 'put', true)
}
export function updateViewsCount_api(id) {
  return apiService(`contents/views-count/${id}`, null, 'put', true)
}
export function updateCopyCount_api(id) {
  return apiService(`contents/copy-count/${id}`, null, 'put', true)
}
export function updateShowAtHomepage_api(uuid) {
  return apiService(`contents/hideAthomepage/${uuid}`, null, 'put', true)
}
export function recentlyViewedContent_api() {
  return apiService(`contents/recentlyViewedContent`, null, 'get', true)
}

export function getAdminPageTemplates_api() {
  return apiService(`templates/admin-templates`, null, 'get', true)
}
export function getTeamPageTemplates_api() {
  return apiService(`templates/team-templates`, null, 'get', true)
}
export function createPageTemplates_api(data) {
  return apiService(`templates/team-templates`, data, 'post', true)
}
export function updatePageTemplates_api(data) {
  return apiService(`templates/team-templates/${data.uuid}`, data, 'put', true)
}
export function deletePageTemplate_api(uuid) {
  return apiService(`templates/team-templates/${uuid}`, null, 'delete', true)
}
export function addResponsePacks_api(data) {
  return apiService(`templates/addResponsePacks`, data, 'post', true)
}
export function pinTemplate_api(data) {
  return apiService(`templates/pin_template`, data, 'post', true)
}

// SUBSCRIPTION
export function createStripeCustomerId_api() {
  return apiService(`createStripeCustomer`, null, 'post', true)
}

export function getPricePlans_api() {
  return apiService(`getPricePlans`, null, 'get', true)
}

export function getCard_api() {
  return apiService(`payment_method`, null, 'get', true)
}
export function createCard_api(data) {
  return apiService(`payment_method`, data, 'post', true)
}
export function deleteCard_api(id) {
  return apiService(`payment_method/${id}`, null, 'delete', true)
}

export function createSubscription_api(data) {
  return apiService(`subscription`, data, 'post', true)
}
export function getActiveSubscription_api() {
  return apiService(`subscription`, null, 'get', true)
}
export function switchPlan_api(data) {
  return apiService(`subscription/changePlan`, data, 'put', true)
}
export function cancelSubscription_api(id, cancelNow) {
  return apiService(`subscription/${id}${cancelNow ? '?cancelNow=true' : ''}`, null, 'delete', true)
}
export function resumeSubscription_api() {
  return apiService(`subscription/resume`, null, 'put', true)
}
export function getInvoices_api() {
  return apiService(`subscription/invoices`, null, 'get', true)
}

export function createIconAndCoverImage(data) {
  return apiService(`media/upload`, data, 'post', true, true)
}

export function deleteIconAndCoverImage(data) {
  return apiService(`media/upload`, data, 'delete', true)
}

export function repositionCoverImage(data) {
  return apiService(`media/reposition`, data, 'put', true)
}

export function fetchCategoryMedia(uuid) {
  return apiService(`media/category/${uuid}`, null, 'get', true)
}